export default __webpack_public_path__ + "static/media/Firefox-Logo.d20095f6.svg";